import clsx from 'clsx';
import React, { ReactNode } from 'react';

import iconEmpty from '~/../static/error-empty.svg';
import { Button, ButtonProps } from '~/components/button/Button';
import { Icon } from '~/components/icon/Icon';

import styles from './ErrorMessage.module.scss';

export interface ErrorButton extends Partial<ButtonProps> {
  label: string;
  onClick?: () => void;
}

export interface ErrorMessageProps {
  className?: string;
  displayIcon?: 'error' | 'empty';
  title?: ReactNode;
  subtitle?: ReactNode;
  buttonProps?: ErrorButton;
}

const EmptyIcon = iconEmpty as React.ComponentType<
  React.SVGProps<SVGSVGElement>
>;

export const ErrorMessage = ({
  className,
  displayIcon,
  title,
  subtitle,
  buttonProps,
}: ErrorMessageProps) => {
  return (
    <div
      className={clsx(styles.wrapper, className)}
      data-testid="widget-error-state"
      data-error-message
    >
      {displayIcon === 'error' && (
        <Icon
          className={styles.errorIcon}
          data-testid="error-icon"
          iconName="ExclamationTriangle"
          size={60}
          viewBox="0 0 60 60"
        />
      )}

      {displayIcon === 'empty' && (
        <EmptyIcon className={styles.emptyIcon} data-testid="empty-icon" />
      )}

      {title && <div className={styles.title}>{title}</div>}
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      <div>
        {buttonProps && (
          <Button
            onClick={buttonProps?.onClick}
            variant="primary"
            size="small"
            {...buttonProps}
          />
        )}
      </div>
    </div>
  );
};
